import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { archivesData } from '../Data/archivesData';
import '../CSS/ArticlePage.css';

const IconDownload = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
);

const ArticlePage = () => {
    const { volumeId, issueId, articleId } = useParams();
    
    // Find the correct volume, issue, and article
    const volumeData = archivesData.find(v => v.volume === parseInt(volumeId, 10));
    const issueData = volumeData?.issues.find(i => i.issue === parseInt(issueId, 10));
    const articleData = issueData?.articles.find(a => a.number === parseInt(articleId, 10));

    if (!articleData) {
        return (
            <div className="article-page-not-found">
                <h2>Article not found</h2>
                <Link to="/archives">Back to Archives</Link>
            </div>
        );
    }

    return (
        <div className="article-page-container">
            <div className="article-main-content">
                <h1 className="article-title">{articleData.title}</h1>
                
                <div className="article-authors-section">
                    <div className="article-author-name">{articleData.authors}</div>
                    {articleData.affiliations && articleData.affiliations.map((affil, idx) => (
                        <div key={idx} className="article-affiliation">{affil}</div>
                    ))}
                    {/* Dummy ORCID for visual similarity if requested, but we'll stick to data if available */}
                    {articleData.orcid && (
                        <div className="article-orcid">
                            <a href={`https://orcid.org/${articleData.orcid}`} target="_blank" rel="noopener noreferrer">
                                https://orcid.org/{articleData.orcid}
                            </a>
                        </div>
                    )}
                </div>

                <div className="article-metadata">
                    {articleData.doi && (
                        <div className="article-doi">
                            <strong>DOI:</strong> <a href={`https://doi.org/${articleData.doi}`} target="_blank" rel="noopener noreferrer">https://doi.org/{articleData.doi}</a>
                        </div>
                    )}
                    
                    {articleData.keywords && (
                        <div className="article-keywords">
                            <strong>Keywords:</strong> {articleData.keywords}
                        </div>
                    )}
                </div>

                <div className="article-abstract-section">
                    <h2 className="article-section-heading">ABSTRACT</h2>
                    <div className="article-abstract-text">
                        {articleData.abstract ? (
                            <p>{articleData.abstract}</p>
                        ) : (
                            <p>Abstract not available for this article.</p>
                        )}
                    </div>
                </div>
            </div>

            <div className="article-sidebar">
                <a 
                    href={articleData.pdfPath} 
                    className="article-pdf-btn"
                    target="_blank" 
                    rel="noopener noreferrer"
                    download
                >
                    <IconDownload /> PDF
                </a>

                <div className="article-sidebar-box">
                    <div className="article-sidebar-box-header">ISSUE</div>
                    <div className="article-sidebar-box-content">
                        <Link to="/archives">Vol. {volumeData.volume} No. {issueData.issue} ({volumeData.year})</Link>
                    </div>
                </div>

                <div className="article-sidebar-box">
                    <div className="article-sidebar-box-header">LICENSE</div>
                    <div className="article-sidebar-box-content">
                        <p>
                            ITME is published Open Access under a <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">Creative Commons CC-BY 4.0 license</a>. Authors retain full copyright, with the first publication right granted to the journal.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArticlePage;
